import { api } from './client';

export interface PostbackLog {
  id: string;
  direction: 'in' | 'out';
  ok: number;
  response_status: number | null;
  click_id: string | null;
  conversion_id: string | null;
  postback_id: string | null;
  attempt: number | null;
  event_type: string | null;
  matched_source: string | null;
  ip: string | null;
  ua: string | null;
  method: string | null;
  endpoint: string | null;
  request_payload: string | null;
  response_body: string | null;
  error: string | null;
  created_at: string;
}

export interface PostbackLogsParams {
  direction?: '' | 'in' | 'out';
  ok?: '' | '1' | '0';
  from?: string;
  to?: string;
  q?: string;
  limit?: number;
  offset?: number;
}

export const listPostbackLogs = (params: PostbackLogsParams) => {
  const qs = new URLSearchParams();
  if (params.direction) qs.set('direction', params.direction);
  // Guard with an explicit check: '0' (Failed) is falsy, so `if (params.ok)`
  // would silently drop the Failed filter.
  if (params.ok === '0' || params.ok === '1') qs.set('ok', params.ok);
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  if (params.q) qs.set('q', params.q);
  qs.set('limit', String(params.limit ?? 50));
  qs.set('offset', String(params.offset ?? 0));
  return api.get<{ rows: PostbackLog[]; total: number }>(`/admin/tracker/postback-logs?${qs.toString()}`);
};
